import(/* webpackMode: "eager" */ "/var/www/crmpl/src/app/installer/page.tsx");
